function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Menu-Icons/Selected/Activities"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.1 23H3.9A3.91 3.91 0 010 19.1V3.9A3.91 3.91 0 013.9 0h15.2A3.91 3.91 0 0123 3.9v15.2a3.91 3.91 0 01-3.9 3.9zM3.9 1.5a2.4 2.4 0 00-2.4 2.4v15.2a2.4 2.4 0 002.4 2.4h15.2a2.4 2.4 0 002.4-2.4V3.9a2.4 2.4 0 00-2.4-2.4H3.9z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.5 10.04h-6.45a.5.5 0 110-1h6.45a.5.5 0 110 1zm-12.54.94a.5.5 0 01-.35-.15L4.19 9.41a.5.5 0 01.71-.71l1.41 1.41a.5.5 0 01-.35.87z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.96 10.98a.5.5 0 01-.35-.85L8.2 7.5a.5.5 0 01.71.71l-2.6 2.6a.5.5 0 01-.35.17zM18.5 16.5h-6.45a.5.5 0 010-1h6.45a.5.5 0 010 1z"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.96 17.98a.5.5 0 01-.35-.15l-1.42-1.41a.5.5 0 01.71-.71l1.41 1.41a.5.5 0 01-.35.86z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.96 17.98a.5.5 0 01-.35-.85L8.2 14.5a.5.5 0 01.71.71l-2.6 2.6a.5.5 0 01-.35.17z"
})), /*#__PURE__*/React.createElement("path", {
  d: "M6.5 0h10v2a2 2 0 01-2 2h-6a2 2 0 01-2-2V0z"
}));
function SvgList(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 23 23",
    ref: svgRef
  }, props), _ref);
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default ForwardRef;